module.exports = {"TXTWCL_Bonus_Amount":{"id":"TXTWCL_Bonus_Amount","defaultMessage":"Importe del bono"}}